module.exports = __webpack_public_path__ + "static/media/workspaceBanner.9e3a61fb.svg";